import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useConfigStore } from "@/stores/config";
import { INSPECTION_COMMENTS } from "@/constants/Inspections";
import { getReportFooter, getReportHeader } from "@/reports/ReportUtil";
import { styles } from "@/reports/reportStyles";

function setWallsDocDefinition(structure) {
  const configStore = useConfigStore();
  let docDefinition = {
    header: function () {
      return getReportHeader("Walls Page", structure);
    },
    footer: function (currentPage, pageCount) {
      return getReportFooter(currentPage, pageCount);
    },
    pageMargins: [20, 70, 20, 50],
    content: [
      { text: "", pageHeaderText: "Walls Page" },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Wall Conditions",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        columns: [
          {
            width: "25%",
            text: "WL.30 Overall Condition Rating: ",
            bold: true,
            margin: [0, 5, 0, 0],
          },
          {
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.WALL_CONDITION_RATING,
              structure.inspectionWall?.strRating
            ),
            margin: [0, 5, 0, 0],
          },
        ],
      },
      {
        text: "Overall Walls Notes: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find((element) => element?.commentType == INSPECTION_COMMENTS.OVERALL_WALL)
          ?.notes,
      },

      {
        columns: [
          {
            width: "25%",
            text: "WL.31 Anchorage: ",
            bold: true,
            margin: [0, 5, 0, 0],
          },
          {
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.WALL_CONDITION_RATING,
              structure.inspectionWall?.anchorageCondRate
            ),
            margin: [0, 5, 0, 0],
          },
          {
            width: "30%",
            text: "WL.36 Drainage: ",
            bold: true,
            margin: [0, 5, 0, 0],
          },
          {
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.WALL_CONDITION_RATING,
              structure.inspectionWall?.drainageCondRate
            ),
            margin: [0, 5, 0, 0],
          },
        ],
      },
      {
        columns: [
          {
            width: "25%",
            text: "WL.32 Backfill: ",
            bold: true,
            margin: [0, 5, 0, 0],
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.WALL_CONDITION_RATING,
              structure.inspectionWall?.backfillCondRate
            ),
          },
          {
            margin: [0, 5, 0, 0],
            width: "30%",
            text: "WL.37 Foundation: ",
            bold: true,
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.WALL_CONDITION_RATING,
              structure.inspectionWall?.foundCondRate
            ),
          },
        ],
      },
      {
        columns: [
          {
            margin: [0, 5, 0, 0],
            width: "25%",
            text: "WL.33 Wall: ",
            bold: true,
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.WALL_CONDITION_RATING,
              structure.inspectionWall?.wallCondRate
            ),
          },
          {
            margin: [0, 5, 0, 0],
            width: "30%",
            text: "WL.38 Parapets: ",
            bold: true,
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.WALL_CONDITION_RATING,
              structure.inspectionWall?.parapetsCondRate
            ),
          },
        ],
      },
      {
        columns: [
          {
            margin: [0, 5, 0, 0],
            width: "25%",
            text: "WL.34 Panel: ",
            bold: true,
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.WALL_CONDITION_RATING,
              structure.inspectionWall?.panelCondRate
            ),
          },
          {
            margin: [0, 5, 0, 0],
            width: "30%",
            text: "WL.21 Primary Backfill Mat'l: ",
            bold: true,
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.BACKFILL_MATERIAL,
              structure.structureWalls?.backfillMaterial1
            ),
          },
        ],
      },
      {
        columns: [
          {
            margin: [0, 5, 0, 0],
            width: "25%",
            text: "WL.35 Post: ",
            bold: true,
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.WALL_CONDITION_RATING,
              structure.inspectionWall?.postCondRate
            ),
          },
          {
            margin: [0, 5, 0, 0],
            width: "30%",
            text: "WL.22 Secondary Backfill Mat'l: ",
            bold: true,
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.BACKFILL_MATERIAL,
              structure.structureWalls?.backfillMaterial2
            ),
          },
        ],
      },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Wall Inspection Notes",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 5, 0, 0],
      },
      {
        text: "Anchorage: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find(
          (element) => element?.commentType == INSPECTION_COMMENTS.WALL_ANCHORAGE
        )?.notes,
      },
      {
        text: "Backfill: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find(
          (element) => element?.commentType == INSPECTION_COMMENTS.WALL_BACKFLIP_DAMPING
        )?.notes,
      },
      {
        text: "Wall: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find((element) => element?.commentType == INSPECTION_COMMENTS.WALL)?.notes,
      },
      {
        text: "Panel: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find((element) => element?.commentType == INSPECTION_COMMENTS.WALL_PANEL)
          ?.notes,
      },
      {
        text: "Post: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find((element) => element?.commentType == INSPECTION_COMMENTS.WALL_POST)
          ?.notes,
      },
      {
        text: "Drainage: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find(
          (element) => element?.commentType == INSPECTION_COMMENTS.WALL_PAGE_DRAINAGE
        )?.notes,
      },
      {
        text: "Foundation: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find(
          (element) => element?.commentType == INSPECTION_COMMENTS.WALL_FOUNDATION
        )?.notes,
      },
      {
        text: "Parapets: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find(
          (element) => element?.commentType == INSPECTION_COMMENTS.WALL_PARAPETS
        )?.notes,
      },
    ],
    styles: styles,

    defaultStyle: {
      fontSize: 10,
    },
  };
  return docDefinition;
}

export { setWallsDocDefinition };
